export const usersConstants = {
    // FETCH
    FETCHONE_SUCCESS: 'FETCHONE_SUCCESS',
    UPDATEONE_SUCCESS: 'UPDATEONE_SUCCESS',
    CREATEONE_SUCCESS: 'CREATEONE_SUCCESS',
    // GET
    GETALL_REQUEST: 'USERS_GETALL_REQUEST',
    GETALL_SUCCESS: 'USERS_GETALL_SUCCESS',
    GETALL_FAILURE: 'USERS_GETALL_FAILURE',
    // DELETE
    DELETE_REQUEST: 'USERS_DELETE_REQUEST',
    DELETE_SUCCESS: 'USERS_DELETE_SUCCESS',
    DELETE_FAILURE: 'USERS_DELETE_FAILURE'    
};
